
import React from 'react';
import PropTypes from 'prop-types';

import {MultiDropdown, DropdownMenuItem} from 'views/components';

import {Translate, translate} from 'views/module';

const ContentEdit = (props) => {
  const bioQuestion = props.bioQuestion;
  const updateQuestionData = props.updateQuestionData;

  const {bioQuestionId, questionData} = bioQuestion;

  const handleChange = (value) => {
    updateQuestionData((prev) => ({
      ...prev,
      value,
    }));
  };

  return (
    <MultiDropdown
      label={translate(`caregiver.CaregiverDetail.Biography.Questions.Titles.${bioQuestionId}`)}
      onChange={handleChange}
      value={questionData.value}
    >
      {
        questionData.options.map((opt, i) => (
          <DropdownMenuItem
            key={i}
            value={opt}
          >
            <Translate expression={`caregiver.CaregiverDetail.Biography.Questions.Options.${bioQuestionId}.${opt}`} />
          </DropdownMenuItem>
        ))
      }
    </MultiDropdown>
  );
};

ContentEdit.propTypes = {
  bioQuestion: PropTypes.shape({
    bioQuestionId: PropTypes.string.isRequired,
    questionData: PropTypes.shape({
      value: PropTypes.array.isRequired,
      options: PropTypes.array.isRequired,
    }).isRequired,
  }).isRequired,
  updateQuestionData: PropTypes.func.isRequired,
};

export default ContentEdit;
